import axios from "axios";

const newClientURL = "new/client/";

export function getCurrentPartnerStepInfo(clientId) {
  return axios.get(`${newClientURL}my-client/${clientId}`);
}

export function postStepData(
  stepData,
  stepNumber,
  isMultipart = false,
  clientId
) {
  const config = {};

  if (isMultipart) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };

    return axios.post(
      `${newClientURL}step${stepNumber}/${stepData?.get("client_id")}`,
      stepData,
      config
    );
  }

  if (stepNumber == "6") {
    if (clientId == 1) {
      return axios.post(
        `${newClientURL}step6ForClientCategory1/${stepData.client_id}`,
        stepData
      );
    } else {
      return axios.post(
        `${newClientURL}step6ForClientCategory2And3/${stepData.client_id}`,
        stepData
      );
    }
  }

  if (stepNumber == "4") {
    let endpoint;
    endpoint = stepData?.haveVoucher
      ? `${newClientURL}step${stepNumber}/${stepData.client_id}/${stepData.package_id}?voucherCode=${stepData?.haveVoucher}`
      : `${newClientURL}step${stepNumber}/${stepData.client_id}/${stepData.package_id}`;

    return axios.post(`${endpoint}`, stepData);
  } else {
    return axios.post(`${newClientURL}step${stepNumber}`, stepData);
  }
}

export function postUpdateStepData(stepData, stepNumber, isMultipart = false) {
  const config = {};

  if (isMultipart) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };

    return axios.post(
      `${newClientURL}step1-update/${stepData.client_id}`,
      stepData,
      config
    );
  }

  return axios.post(
    `${newClientURL}step1-update/${stepData.client_id}`,
    stepData
  );
}

// step2
export function resendOtp(clientId) {
  return axios.get(`${newClientURL}resend-otp/${clientId}`);
}
// step3
export function checkWalletBalance(clientId) {
  return axios.get(`${newClientURL}step3-wallet/${clientId}`, {
    client_id: clientId,
  });
}

export function getPaymentMethods() {
  return axios.get(`${newClientURL}payment_methods`);
}
// step4
export function getPackages(clientId) {
  return axios.get(`${newClientURL}packages/${clientId}`);
}
// get packages depend on payment channel
export function getPackagesByPaymentChannel(clientId, voucherCode) {
  return axios.get(`/new/client/packages/${clientId}`, {
    params: {
      voucherCode,
    },
  });
}

export function getMyWalletBalance() {
  return axios.get(`${newClientURL}my-wallet/registration`);
}

// step5
export function getEducationalLevel() {
  return axios.get(`${newClientURL}educations`);
}

export function getJobCategories() {
  return axios.get(`${newClientURL}jobs`);
}

export function getCountries() {
  return axios.get(`${newClientURL}countries`);
}

// step6
export function getPartnersBySearch(searchKey, clientCategoryId) {
  if (clientCategoryId == 1) {
    return axios.get(
      `client/tree/search?val=${searchKey}&isClientCategory1=true`
    );
  } else {
    return axios.get(`client/tree/search?val=${searchKey}`);
  }
}

export function getDirectPartnersBySearch(uplinerId, searchKey) {
  return axios.get(
    `client/tree/upliner/search?upliner_id=${uplinerId}&val=${searchKey}`
  );
}

export function checkUplinerPartnerHasLeftOrRight(uplinerPartnerID) {
  return axios.get(
    `client/tree/Upliner-available-children/${uplinerPartnerID}`
  );
}
